import React, { memo } from 'react';

import { SCOUT_CREATE_TYPE } from '../../../../constants';
import CardMark from '../../../../scout/components/message-card/CardMark';

import scss from './MessagesList.module.scss';

const MessageCard = ({ message: messageProps = {} }) => {
  const { message, count, createType } = messageProps;

  return (
    <div className={scss.itemWrapper}>
      <div className={scss.cardWrapper}>
        <div className={scss.idCell}>{count}</div>

        <div className={scss.contentWrapper}>
          <div className={scss.textCell}>{message}</div>
        </div>
      </div>
      <CardMark
        isGenerated={createType === SCOUT_CREATE_TYPE.GENERATED}
        isCompressed={createType === SCOUT_CREATE_TYPE.COMPRESSED}
      />
    </div>
  );
};

export default memo(MessageCard);
